<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<p class="title1">MARKETS OF <em>Provence</em></p>
<p class="title2">Food, Antiques, Crafts, and More</p>
<p class="title3">Text and photographs by</p>
<p class="title4">Marjorie R. Williams</p>
<p class="title5">with Dixon Long</p>
<p class="figure_logo"><img alt="" src="OEBPS/images/logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?7f527bc8